module.exports = __webpack_public_path__ + "img/mpsyr.8ead24be.svg";